import React, { useEffect, useMemo, useState } from "react";
import DownArrow from "../../../../assets/svg/Distribution/downArrow.svg";
import RightArrow from "../../../../assets/svg/Distribution/rightArrow.svg";
import Loader from "../../../../component/Loader/Loader";
import rightarrow from "../../../../assets/images/rightvector.png";
import leftarrow from "../../../../assets/images/Vector.png";

export const TableListView = ({tableData, loading, allChannelsListColl}) => {
    const filteredChannels = useMemo(() => {
    return tableData?.map((item) => {
      const matchedChannel = allChannelsListColl?.find(
        (channel) => item.channelName?.toUpperCase() === channel.channelId
      );
      return {
        ...item,
        name: matchedChannel?.name || '',
      };
    });
  }, [tableData, allChannelsListColl]);
  

    const [expandedRow, setExpandedRow] = useState(null);
    const [programsPage, setProgramsPage] = useState({});
    const rowsPerPage = 10;
    
    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const tdValues = ['2345', '05:35:03', '300', '05:35:03', '05:35:03'];
    return (
        <div className="distributionContainer">
            <div className="tableWrapper p-0">
                <table className="cms-table-list">
                    <thead>
                        <tr>
                            {/* <th className="col-toggle"></th> */}
                            <th className="col-name">
                                <label>CHANNEL NAME</label>
                            </th>
                            <th className="col-name text-center">
                                <label>ACTIVE VIEWERS</label>
                            </th>
                            <th className="col-name text-center">
                                <label>TOTAL WATCH TIME</label>
                            </th>
                            <th className="col-name text-center">
                                <label>TOTAL SESSIONS</label>
                            </th>
                            <th className="col-name text-center">
                                <label className="lh-1">AVG - WATCH TIME <br/><span>PER USER(HH:MM:SS)</span></label>
                            </th>
                            <th className="col-name text-center">
                                <label className="lh-1">AVG - WATCH TIME <br/><span>PER SESSION(HH:MM:SS)</span></label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                        <tr>
                            <td colSpan="6" className="text-center">
                                <div className="tableLoader">
                                    <Loader></Loader>
                                </div>
                            </td>
                        </tr>
                        ) : filteredChannels?.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center">
                                No platforms found
                            </td>
                        </tr>
                        ) : (
                            filteredChannels?.map((row, index) => {
                                const currentPage = programsPage[index] || 1;
                                const startIndex = (currentPage - 1) * rowsPerPage;
                                const paginatedPrograms = row?.programs?.slice(startIndex, startIndex + rowsPerPage);
                                const totalPages = Math.ceil(row?.programs?.length / rowsPerPage);
                                return (
                                    <React.Fragment key={row.id}>
                                        <tr className="parentRow" onClick={() => toggleRow(index)}>
                                            <td className="col-toggle"
                                                style={{border:`${expandedRow === index? "none": ""}`}}
                                            >
                                                <span className="toggleIcon me-2">
                                                {expandedRow === index ? (
                                                    <img src={DownArrow} alt="Collapse" />
                                                ) : (
                                                    <img src={RightArrow} alt="Expand" />
                                                )}
                                                </span>
                                                {row?.name}
                                            </td>
                                            <td key={row.id} className="col-name text-center" style={{border:`${expandedRow === index? "none": ""}`}}>
                                                {row?.activeUsers}
                                            </td>
                                            <td key={row.id} className="col-name text-center" style={{border:`${expandedRow === index? "none": ""}`}}>
                                                {row?.totalWatchTime}
                                            </td>
                                            <td key={row.id} className="col-name text-center" style={{border:`${expandedRow === index? "none": ""}`}}>
                                                {row?.totalSession}
                                            </td>
                                            <td key={row.id} className="col-name text-center" style={{border:`${expandedRow === index? "none": ""}`}}>
                                                {row?.avgWatchTime}
                                            </td>
                                            <td key={row.id} className="col-name text-center" style={{border:`${expandedRow === index? "none": ""}`}}>
                                                {row?.avgWatchTimeBySession}
                                            </td>
                                        </tr>
                                        {expandedRow === index && (
                                            row?.programs.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No platforms found
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {paginatedPrograms.map((data, i) => (
                                                        <tr key={i} className="childRow">
                                                            <td className="col-name">{data?.programTitle}</td>
                                                            <td className="col-name text-center">{data?.activeUsers}</td>
                                                            <td className="col-name text-center">{data?.totalWatchTime}</td>
                                                            <td className="col-name text-center">{data?.totalSession}</td>
                                                            <td className="col-name text-center">{data?.avgWatchTime}</td>
                                                            <td className="col-name text-center">{data?.avgWatchTimeBySession}</td>
                                                        </tr>
                                                    ))}
                                                    {/* Pagination Controls */}
                                                    {totalPages > 1 && (
                                                        <tr>
                                                            <td colSpan="3" className="text-start">
                                                                <span>Showing {rowsPerPage*currentPage} of {row?.programs.length} entries</span>
                                                            </td>
                                                            <td colSpan="3" className="text-end">
                                                                <button
                                                                className="rounded"
                                                                onClick={() =>
                                                                    setProgramsPage((prev) => ({
                                                                    ...prev,
                                                                    [index]: Math.max((prev[index] || 1) - 1, 1),
                                                                    }))
                                                                }
                                                                disabled={currentPage === 1}
                                                                >
                                                                    <img src={leftarrow} alt="left arrow" />
                                                                </button>{' '}
                                                                Page {currentPage} of {totalPages}{' '}
                                                                <button
                                                                className="rounded"
                                                                onClick={() =>
                                                                    setProgramsPage((prev) => ({
                                                                    ...prev,
                                                                    [index]: Math.min((prev[index] || 1) + 1, totalPages),
                                                                    }))
                                                                }
                                                                disabled={currentPage === totalPages}
                                                                >
                                                                    <img src={rightarrow} alt="right arrow" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            )
                                        )}
                                    </React.Fragment>
                                )
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}